
export const NAME = 'Modal';



// WEBPACK FOOTER //
// ./modules/Modal/redux/constants.js